// extracted by mini-css-extract-plugin
export default {"download-template":"UsersTab_download-template__jnWEH","icon":"UsersTab_icon__ayVuI"};